import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../icons/x-hex.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { ReturnToBookingPortal } from './buttons';
import { CustomerSupportLink } from '../buttons';
import { BookingUpdateErrorProps } from './types';

export const BookingUpdateError = ({ linkTo }: BookingUpdateErrorProps) => {
	const { t } = useTranslation();
	return (
		<ResultPageLayout headerIcon={ErrorIcon} iconAltText={t('errors.oops_something_went_wrong')}>
			<ResultPageLayout.Title>{t('titles.oops')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>{t('messages.booking_update_problem')}</p>
				<p>{t('messages.contact_support_to_resolve')} <CustomerSupportLink /></p>

				<ResultPageLayout.Footer>
					{linkTo ? <ReturnToBookingPortal to={linkTo} /> : null}
				</ResultPageLayout.Footer>
			</ResultPageLayout.Body>
		</ResultPageLayout>
	);
};
